//fix me
const Preconditions = require('preconditions').singleton();
export default Preconditions;